import { AnalyticsBrowser } from '@segment/analytics-next';
import * as React from 'react';
const AnalyticsContext = React.createContext<AnalyticsBrowser | null>(null);
interface AnalyticsProviderProps {
  children: React.ReactNode;
}
const WRITE_KEY = process.env.NEXT_PUBLIC_SEGMENT_WRITE_KEY || '';
export const AnalyticsProvider = ({
  children
}: AnalyticsProviderProps) => {
  const analytics = React.useMemo(() => AnalyticsBrowser.load({
    writeKey: WRITE_KEY
  }), []);
  return <AnalyticsContext.Provider value={analytics} data-sentry-element="AnalyticsContext.Provider" data-sentry-component="AnalyticsProvider" data-sentry-source-file="analytics-context.tsx">
      {children}
    </AnalyticsContext.Provider>;
};
export const useAnalytics = () => {
  const analyticsProviderContext = React.useContext(AnalyticsContext);
  if (!analyticsProviderContext) {
    throw new Error('`useAnalytics` must be called from within an `AnalyticsProvider`');
  }
  return analyticsProviderContext;
};